import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { captureRef, safeLocalStorage } from './lib/ref';
import './styles.css';

// Capture a reference link's slug once at boot, before anything renders: the
// visitor may leave and come back directly, and the submit form reads the
// stored value at submit time rather than the live query string.
captureRef(window.location.search, safeLocalStorage());

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
